import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModuleFlow, handleError } from '../../../../shared/utils/error.utils';
import { buildHttpParams } from '../../../../shared/utils/http.utils';
import { NationalityRepository } from '../../domain/repository';
import { ApiResponse } from '../../../../shared/dto/response/api-response.dto';
import { getApiBaseUrl } from '../../../../shared/config/runtime-config';
import {
  NationalityFindAllRequest,
  NationalityFindAllResponse,
  NationalityFindRequest,
  NationalityFindResponse,
} from '../../domain/dto';

@Injectable({ providedIn: 'root' })
export class NationalityRepositoryImpl implements NationalityRepository {
  constructor(private http: HttpClient) {}

  findAllPath(): string {
    return this.apiUrl;
  }

  findAll(payload: NationalityFindAllRequest = {}): Observable<HttpResponse<NationalityFindAllResponse>> {
    const params = buildHttpParams(payload);

    return this.http
      .get<ApiResponse<NationalityFindAllResponse>>(this.findAllPath(), {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) => response.clone({ body: response.body?.data ?? [] })),
        catchError((error) => handleError(ModuleFlow.NationalityFindAll, error)),
      );
  }

  find(payload: NationalityFindRequest): Observable<HttpResponse<NationalityFindResponse>> {
    return this.http
      .get<ApiResponse<NationalityFindResponse>>(`${this.apiUrl}/${payload.id}`, {
        observe: 'response',
      })
      .pipe(
        map((response) => response.clone({ body: response.body?.data })),
        catchError((error) => handleError(ModuleFlow.NationalityFind, error)),
      );
  }

  private get apiUrl(): string {
    return getApiBaseUrl('catalogs/nationalities');
  }
}


